import {web_search_filter} from './web_search_filter';
import {web_search_filter_tag_product} from './web_search_filter_tag_product';
export class web_search_filter_tag {
    public id:number;
    public name:string;
    public filter_id:number;
    public web_search_filter:web_search_filter;
    public tag_products:web_search_filter_tag_product[]=[];

}